export enum Level {
  ERROR = 'error',
  INFO = 'info',
  WARN = 'warn',
  SUCCESS = 'success',
  DETAIL = 'detail',
  NEUTRAL='neutral',
}
